export function hasTouchEvents() {
    return 'ontouchcancel' in document.documentElement 
            && 'ontouchend' in document.documentElement 
            && 'ontouchmove' in document.documentElement 
            && 'ontouchstart' in document.documentElement;
}